import 'overlayscrollbars/overlayscrollbars.css';
import {OverlayScrollbars} from 'overlayscrollbars';

const mainWrap = $('.main-page-wrap');
const firstSection = mainWrap.find('section').eq(0);
const backToTop = $('#backToTop');

//  Use descriptive variable names for clarity.
const isSectionEmpty = mainWrap.find('section').length > 0;
const isFirstSectionBlack = firstSection.hasClass('-black');
const isFirstSectionHeroType5 = firstSection.hasClass('hero-type-5');

if (!isSectionEmpty || !isFirstSectionBlack) {
    $('.site-header').addClass('-main-positive');
}

if (isFirstSectionHeroType5 && isFirstSectionBlack) {
    $('.site-header').addClass('-main-menu-white');
}

if (isSectionEmpty) {
    scrTop();
}
checkButton();

$(window).scroll(function () {
    if (isSectionEmpty) {
        scrTop();
    }
    checkButton();
});

$(".menu-opener").on("click", function () {
    //  Use toggleClass with a boolean argument for better readability.
    const siteHeader = $(".site-header");
    const isActive = $(this).hasClass("-active");
    $(this).toggleClass("-active", !isActive);
    siteHeader.toggleClass("open-menu", !isActive);

    //  Use ternary operator for concise code.
    $("body").toggleClass("-overflow-hidden", !isActive);

    $(".modal-menu [data-overlayscrollbars-viewport]").animate({
        scrollTop: 0
    }, 0);
});

$('.scroll-container').each(function (index, el) {
    OverlayScrollbars({
        target: el,
        sizeAutoCapable: true,
        paddingAbsolute: false,
    }, {});
})

function scrTop() {
    const scrTop = $(window).scrollTop();
    let offsetTop = 94;

    if (firstSection.hasClass('-black')) {
        offsetTop = firstSection.innerHeight() - 94;
    }

    //  Use a ternary operator for concise code.
    $(".site-header").toggleClass("-fixed", scrTop > offsetTop);
}

backToTop.on('click', function (e) {
    e.preventDefault();
    $('html, body').animate({
        scrollTop: 0
    }, '1000');
});

function checkButton() {
    //  Calculate the window height once for efficiency.
    const windowHeight = $(window).height();
    backToTop.toggleClass('-show', $(window).scrollTop() > windowHeight * 3);
}

// edit logic sticky header
const siteHeader = $("header");
let changeHeader = false;
let lastScrollPosition = 0;

function handleScroll() {
    const currentScrollPosition = window.scrollY;
    const headerHeight = siteHeader.height();

    if (currentScrollPosition >= headerHeight) {
        if (currentScrollPosition > lastScrollPosition) {
            addHeaderClass();
        } else {
            removeHeaderClass();
        }
    }
    lastScrollPosition = currentScrollPosition;
}

function addHeaderClass() {
    if (changeHeader === true) {
        return;
    }
    changeHeader = true;
    siteHeader.addClass("show-fixed");
}
function removeHeaderClass() {
    changeHeader = false;
    siteHeader.removeClass("show-fixed");
}
$(document).ready(function () {
// Attach the "handleScroll" function to the scroll event
    $(window).scroll(handleScroll);
});